import React from 'react';

import { Paragraph, Button, Heading as H } from '@periodica/ui-kit';
import { Gift } from '@periodica/ui-kit/icons';
import { ShareLinkButton } from '@components/ShareLink';

import icon1 from '@images/icons/gift/icon1.svg';
import icon2 from '@images/icons/gift/icon2.svg';
import icon3 from '@images/icons/gift/icon3.svg';
import icon4 from '@images/icons/gift/icon4.svg';

import styles from './GiftBanner.module.scss';

const icons = [icon1, icon2, icon3, icon4];

export function GiftBanner() {
  const about = [
    {
      id: 1,
      text: 'Выберите готовый дизайн или загрузите свое изображение в шаблон',
    },
    {
      id: 2,
      text: 'Отправьте получателю на электронную почту или распечатайте, чтобы вручить лично',
    },
    {
      id: 3,
      text: 'Можно использовать несколько раз до исчерпания баланса',
    },
    {
      id: 4,
      text: 'Действует 1 год с момента получения     ',
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.mainGiftBanner}>
        <div className={styles.block}>
          <H className={styles.title} color="secondary">
            Подарочные сертификаты
          </H>
          <div className={styles.list}>
            {about.map((item, idx) => (
              <div key={item.id} className={styles.listItem}>
                <img src={icons[idx]} alt="icon" className={styles.listIcon} />
                <Paragraph
                  className={styles.paragraph}
                  size="large"
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.shareBtnContainer}>
          <ShareLinkButton category="gift">
            <Button className={styles.btnGift} size="large" type="button" variant="brandSecondary">
              <Gift /> Намекнуть о подарке
            </Button>
          </ShareLinkButton>
        </div>
      </div>
    </div>
  );
}
